/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { ChangeEvent, FormEvent } from 'react';
import axios from 'axios';

import { useFlipOIDC } from './FlipOIDC';

export default function DemoConfig({ children }: React.PropsWithChildren) {
  const { token } = useFlipOIDC();

  const [show, setShow] = React.useState(false);
  const [clientId, setClientId] = React.useState('');
  const [clientSecret, setClientSecret] = React.useState('');
  const [domain, setDomain] = React.useState('');

  async function handleSubmit(evt: FormEvent) {
    evt.preventDefault();

    await axios.post('/api/v2/config', { clientId, clientSecret, domain }, {
      headers: { Authorization: `Bearer ${token}` },
    });

    // Reload
    const { data } = await axios.get('/api/v2/config', {
      headers: { Authorization: `Bearer ${token}` },
    });

    setClientId(data.clientId);
    setClientSecret(data.clientSecret);
    setDomain(data.domain);
  }

  function handleClientIdChange(evt: ChangeEvent<HTMLInputElement>) {
    setClientId(evt.target.value);
  }

  function handleClientSecretChange(evt: ChangeEvent<HTMLInputElement>) {
    setClientSecret(evt.target.value);
  }

  function handleDomainChange(evt: ChangeEvent<HTMLInputElement>) {
    setDomain(evt.target.value);
  }

  React.useEffect(() => {
    function keydown(e: KeyboardEvent) {
      if (e.key === '/' && e.ctrlKey) {
        setShow(!show);
      }
    }

    document.addEventListener('keypress', keydown);

    return () => {
      document.removeEventListener('keypress', keydown);
    };
  }, [show]);

  React.useEffect(() => {
    async function load() {
      const { data } = await axios.get('/api/v2/config', {
        headers: { Authorization: `Bearer ${token}` },
      });

      setClientId(data.clientId);
      setClientSecret(data.clientSecret);
      setDomain(data.domain);
    }

    try {
      if (show) load();
    } catch (err) {
      // Only admins can retrieve this
    }
  }, [show, token]);

  if (show) {
    return (
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="clientId">Client ID</label>
          <input type="text" name="clientId" id="clientId" value={clientId} onChange={handleClientIdChange} />
        </div>
        <div>
          <label htmlFor="clientSecret">Client Secret</label>
          <input type="text" name="clientSecret" id="clientSecret" value={clientSecret} onChange={handleClientSecretChange} />
        </div>
        <div>
          <label htmlFor="domain">Domain</label>
          <input type="text" name="domain" id="domain" value={domain} onChange={handleDomainChange} />
        </div>
        <div>
          <button type="submit">Update</button>
        </div>
      </form>
    );
  }

  return children;
}
